<template>
    <div
        class="flex flex-column item sidebar-item justify-content-start align-items-center morelinks"
        :class="{ wide: wide }"
        @click="toggleMoreLinks"
    >
        <div class="flex justify-content-center align-items-center">
            <i class="pi pi-ellipsis-v mr-2"></i>
            <span v-if="wide" :class="{ wide: wide }">More Links</span>
            <span v-else>More</span>
        </div>
        <div v-if="isOpen" class="submenu" :class="{ wide: wide }">
            <Menu :model="moreLinkItems">
                <template #item="{ item }">
                    <div
                        v-if="item.link"
                        class="flex align-items-center third-menu-item"
                        :class="item.className"
                        @click="goToLink(item.link)"
                    >
                        <span class="material-icons-round" :style="item.style">{{ item.icon }}</span>
                        <span class="mx-2" :style="item.style">{{ item.label }}</span>
                    </div>

                    <div
                        v-else
                        class="flex align-items-center third-menu-item py-3"
                        :class="item.className"
                        @click="
                            item.command ? item.command() : false;
                            item.to ? $router.push(item.to) : false;
                        "
                    >
                        <span class="material-icons-round" :style="item.style">{{ item.icon }}</span>
                        <span class="mx-2" :style="item.style">{{ item.label }}</span>
                    </div>
                </template>
            </Menu>
        </div>
    </div>
</template>

<script>
import { inject, onBeforeUnmount, ref } from 'vue';
import { useStore } from 'vuex';

export default {
    props: {
        wide: {
            type: Boolean,
        },
    },
    setup(props, context) {
        const store = useStore();
        const isOpen = ref(false);
        const toggleMoreLinks = () => {
            if (!isOpen.value) {
                context.emit('setSubmenu', 'false');
            }
            isOpen.value = !isOpen.value;
        };
        const bus = inject('bus');

        const moreLinkItems = ref([
            {
                label: 'Welcome Tour',
                icon: 'play_circle_outline',
                command: () => {
                    store.dispatch('setActiveModal', { modal: 'WelcomeTour' });
                },
            },
            {
                label: 'FAQs',
                icon: 'quiz',
                to: '/faqs/questions',
            },
            {
                label: 'Refer a Friend',
                icon: 'person_add',
                to: '/settings/personal?scrollto=clientreferral',
                className: 'refer-friend-link',
            },
        ]);

        const goToLink = (link) => {
            window.open(link, '_blank');
        };

        bus.on('clearMoreLinks', () => {
            isOpen.value = false;
        });

        onBeforeUnmount(() => {
            bus.off('clearMoreLinks');
        });

        return {
            isOpen,
            moreLinkItems,
            toggleMoreLinks,
            goToLink,
        };
    },
};
</script>
<style scoped lang="scss">
.morelinks {
    position: fixed;
    bottom: 35px;
    /* width: 100%; */
    color: var(--clarity-pure-white);
    cursor: pointer;
}

.submenu {
    position: fixed;
    left: 160px;
    bottom: 20px;
}

.submenu :deep(.p-menu) {
    padding: 20px;
    white-space: nowrap;
    width: unset;
}

.submenu.wide {
    left: 485px;
    font-size: 14px;
}

.wide {
    width: unset;
    left: 20px;
}

span.wide {
    font-size: 18px;
    @media only screen and (max-width: 1366px) {
        font-size: 14px;
    }
}

.third-menu-item {
    padding-top: 14px;
    padding-bottom: 14px;
    cursor: pointer;

    &:hover {
        color: var(--clarity-blue);

        .material-icons-round {
            color: var(--clarity-blue);
        }
    }

    &.refer-friend-link {
        color: var(--clarity-orange);
        .material-icons-round {
            color: var(--clarity-orange);
        }
        &:hover {
            color: var(--clarity-dark-orange);

            .material-icons-round {
                color: var(--clarity-dark-orange);
            }
        }
    }
}

@media only screen and (max-width: 1366px) {
    .third-menu-item {
        padding-top: 6px;
        padding-bottom: 6px;
    }
    .submenu :deep(.p-menu) {
        padding-top: 11px;
        padding-bottom: 11px;
    }
}
</style>
